import * as Main from "../output/Unlockable.Wallet.Main";
Main.main();